import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const SlotMachine = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="193" viewBox="0 0 275 193" width="275" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M117.54 81.86H90.73c2.6-2.72 5.56-5.01 8.74-6.07a15 15 0 0 1 4.53-.87l1.07.07h.02c4.97.67 5.58 6 12.44 6.87z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M218.46 2.79c-.72-.23-5.05-1.23-11.36 4.98-2.99 2.94-5.67 8.43-8.24 14.55l-.37.9q-1.08 2.63-2.14 5.31l-.43 1.09c-2.32 5.88-4.59 11.65-6.96 15.76a9 9 0 0 1-1.91 2.25 11.3 11.3 0 0 1-7.63 2.77 9.1 9.1 0 0 1-6.88-3.7l-.54-.73c-5.34-7.81-6.3-17.01-16.69-18.4l-2.02-.25c1.68-3.64 3.86-8.24 5.61-11.62C162.27 9.2 168.31.78 177.28.78s13.7-.78 29.82.01q6.5.32 11.36 2.01z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m234.79 21.34-36.3 1.88.37-.9c2.57-6.12 5.25-11.62 8.24-14.55 6.31-6.21 10.64-5.21 11.36-4.98h.02l.05.02.03.01c8.73 3.04 13.7 9.28 16.15 18.24l.07.27z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m236.39 57.03-.13 4.09-49.6.85q.11-1.63.19-3.31.26-5.34.19-11.03a9 9 0 0 0 1.91-2.25c2.36-4.12 4.63-9.89 6.96-15.76l.43-1.09c.74-1.87 1.3-3.31 2.14-5.31l36.3-1.88.25 1.06c1.72 7.99 1.68 23.44 1.36 34.64z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M155.32 27.58q-1.17.02-2.26.27c-6.27 1.41-10.32 8.23-13.14 15.5a100 100 0 0 0-2.4 7.06c-1.15 3.8-2.05 7.26-2.84 9.62-2.92 8.66-8.3 22.96-17.14 21.84-6.87-.87-7.47-6.21-12.44-6.87h-.02a750 750 0 0 0-13.73-.73c7.52-6.71 13.55-26.92 16.21-33.73 2.92-7.46 7.4-14.34 16.48-14.34 5.03 0 17.22-.28 29.27 1.14l2.02.25z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m236.26 61.12-.25 5.94h-49.77q.26-2.5.42-5.09z" fill={shades.black} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M104 74.92c-1.23 0-2.7.26-4.53.87-3.18 1.05-6.14 3.35-8.74 6.07-6.21 6.49-10.33 15.36-10.33 15.36H50.57c5.83-20.3 19.96-23.27 29.16-23.27 3.32 0 7.55.13 11.6.31 5.41.23 10.5.53 12.66.66z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M179.42 50.41h-41.89c.69-2.29 1.48-4.7 2.39-7.06 2.82-7.27 6.86-14.09 13.14-15.5a11 11 0 0 1 2.26-.27c10.38 1.39 11.34 10.59 16.69 18.4q.25.39.54.73a9.1 9.1 0 0 0 6.88 3.7z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path d="M184.01 39.46h-13.49" stroke="white" strokeWidth={strokeWidth} />
      <path d="M187.42 32.09h-21.84" stroke="white" strokeWidth={strokeWidth} />
      <path d="m229.84 34.39-33.33 1.65" stroke={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path d="m230.14 41.46-36.56 1.31" stroke={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path d="m230.14 47.98-36.56 1.15" stroke={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path d="M192.21 19.27h-28.2" stroke="white" strokeWidth={strokeWidth} />
      <path d="M195.42 12.98h-27.09" stroke="white" strokeWidth={strokeWidth} />
      <path d="M199.93 7.11h-26.69" stroke="white" strokeWidth={strokeWidth} />
      <path d="M189.9 25.43h-29.08" stroke="white" strokeWidth={strokeWidth} />
      <path d="m230.37 54.56-37.02.72" stroke={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path d="m229.21 28.18-30.74 1.44" stroke={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path d="M69.73 91.66H56.32" stroke="white" strokeWidth={strokeWidth} />
      <path d="M82.69 86.09H59.91" stroke="white" strokeWidth={strokeWidth} />
      <path d="M86.97 81.14H64.19" stroke="white" strokeWidth={strokeWidth} />
      <path d="m124.69 72.1-25.05-1.05" stroke={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path d="m129.07 60.62-22.94-.94" stroke={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path d="m127.25 66.14-23.52-.97" stroke={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path d="m130.77 55.02-22.05-.91" stroke={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path d="m132.24 49.13-21.5-.88" stroke={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path d="m133.64 43.64-21.18-.87" stroke={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path d="m135.36 38.07-21.05-.87" stroke={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path d="m139.42 32.58-21.95-.43" stroke={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path d="m80.95 89.33-1.66 4.32h-2.15l.82-2.16h-2.15l-.83 2.16h-2.16l1.66-4.32z" fill={shades.black} />
      <path
        className={strokeStyle}
        d="m177.23 78.37-1 68.53h42.46l1.51-68.53zm37.42 29.67h-33.43v-4.44h33.43zm0-9.88h-33.04l.51-16.29h32.92z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M187.1 98.16h-5.49l.51-16.29h5.19a47 47 0 0 0-.21 16.29Z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m220.3 73.96-.1 4.41h-42.97l.07-4.41z" fill={shades.primary.dark} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="m244.72 73.96-3.79 2.96-.06 4.02-20.67-2.57.1-4.41z" fill={shades.black} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m244.81 67.06-.09 6.9H177.3l-3.5-1.82v-5.08z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m240.99 80.96-.12-.02" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="m234.71 90.83-1.79 34.77h-5.83l1.44-37.23 4.02 1.6z" fill={shades.black} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M196.03 98.16h-8.94a47 47 0 0 1 .21-16.29h8.94a47 47 0 0 0-.21 16.29Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M204.97 98.16h-8.94a47 47 0 0 1 .21-16.29h8.94a47 47 0 0 0-.21 16.29Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M213.91 98.16h-8.94a47 47 0 0 1 .21-16.29h8.94a47 47 0 0 0-.21 16.29Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M184.85 103.6h-3.63v4.44h3.63z" fill={shades.white} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M214.65 103.6h-29.8v4.44h29.8z" fill={shades.black} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="m215.03 81.86-.38 16.29h-.74a47 47 0 0 1 .21-16.29z" fill={shades.black} strokeWidth={strokeWidth} />
      <path d="M193.54 92.6a9 9 0 0 0 0 3.12h-1.56a8 8 0 0 1-.13-1.56h-1.56q0 .78.13 1.56h-1.56a9 9 0 0 1 0-3.12z" fill={shades.black} />
      <path d="M201.98 88.14a9 9 0 0 0 0 3.11h-1.56a8 8 0 0 1-.13-1.56h-1.56q0 .78.13 1.56h-1.56a9 9 0 0 1 0-3.11z" fill={shades.black} />
      <path d="M211.64 84.92a9 9 0 0 0 0 3.12h-1.56a8 8 0 0 1-.13-1.56h-1.56q0 .78.13 1.56h-1.56a9 9 0 0 1 0-3.12z" fill={shades.black} />
      <path
        className={strokeStyle}
        d="m14.24 153.41 2.62 34.09 4.4.03c18.82.13 92.41.61 110.95.21 2.73-.06 4.26-.14 4.26-.24 0-.64 1.04-22.03 1.62-34.09z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m138.5 145.33-.08 1.57-.32 6.5H14.24l-.62-8.07z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m144.12 146.9-.46 6.5a6416 6416 0 0 0-2.63 38.8H21.54l-.28-4.68c18.82.13 92.41.61 110.95.21 2.73-.06 4.26-.14 4.26-.24 0-.64 1.04-22.03 1.62-34.09l.32-6.5z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M217.79 187.9h-3.04v-.02z" fill={shades.black} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m220.21 78.38-1.51 68.53h.01l-.02.2v-.2h-74.57l-.46 6.5c-.67 9.5-1.7 24.16-2.34 34.11l14.58.07 6.78.04 9.9.05 10.11.05 12.66.06 3.6.02 15.8.07h3.03l19.87.01 3.22-106.95-20.67-2.57zm12.71 47.22h-5.83l1.44-37.23 4.02 1.6 2.16.86z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M214.75 187.88v.02l-8.88-.05-6.92-.04z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m237.66 187.9-2.26 4.31h-94.37l.29-4.68 14.58.07 6.78.04 9.9.05 10.11.05 12.66.06 3.6.02 15.8.07h3.03z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path d="M77.53 160.76v9.34h-4.67v-4.67h-4.67v4.67h-4.66v-9.34z" fill={shades.black} />
      <path
        className={strokeStyle}
        d="m182.72 113.29-8.79.72-.43-.31-.15-.1-.4-.27-.41-.26q-.4-.25-.83-.48l-.21-.11-.26-.14-.26-.13-.02-.01-.03-.01-.23-.11-.27-.13-.27-.12-.17-.07-.17-.07-.21-.09h-.02l-.06-.02-.19-.07h-.01l-.55-.2-.17-.06-.04-.01-.07-.02-.22-.07-.15-.05-.35-.1-.07-.02-.21-.06q-.06 0-.11-.03-.06 0-.11-.03h-.02l-.06-.01-.16-.04-.02-1.11 1.78-.21.44-.05h.01a19 19 0 0 1 13.53 3.88z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m186.55 117.05-7.19.89-1.26.08-.17-.21-.18-.21-.18-.21-.18-.21-.23-.25-.11-.12-.12-.13-.31-.32-.24-.24-.33-.32-.14-.13-.14-.13-.49-.43-.03-.03-.21-.17-.01-.01-.08-.07-.08-.07-.04-.04-.12-.1-.05-.04-.03-.02-.15-.12-.14-.11-.09-.07-.05-.04-.02-.01-.27-.2 8.79-.72a22 22 0 0 1 3.83 3.76z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M178.11 118.02c-3.2.29-6.25 1.21-9.05 2.66a26 26 0 0 0-3.15-2.23c.7-2.39 1.08-4.95 1.08-7.6v-.06l.16.04.06.01h.02q.06 0 .11.03.06 0 .11.03l.21.06.07.02.35.1.15.05.22.07.07.02.04.01.17.06.55.2h.01l.19.07.06.02h.02l.21.09.17.07.17.07.27.12.27.13.23.11.03.01.02.01.26.13.26.14.21.11q.42.22.83.48l.41.26.4.27.15.1.43.31.27.2.02.01.05.04.09.07.14.11.15.12.03.02.05.04.12.1.04.04.08.07.08.07.01.01.21.17.03.03.49.43.14.13.14.13.33.32.24.24.31.32.12.13.11.12.23.25.18.21.18.21.18.21.17.21z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m157.66 90.94-8.79.72a19 19 0 0 0-11.16-3.71q-1.06 0-2.07.12l8.04-.95h.02l.58-.07a19 19 0 0 1 13.38 3.89Z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m163.33 97.34-8.6.7a22 22 0 0 0-5.86-6.38l8.79-.72a23 23 0 0 1 5.66 6.4z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M158.56 111.85v.75q0 .38-.03.74l-.02.37-.03.37v.02l-.04.44v.02l-.05.42-.05.44a24 24 0 0 0-7.35-.46h-.04l-.61.07-.55.07-5 .62q-.8-.74-1.64-1.39a19 19 0 0 0-14.25-3.78l-6.87.83h-.01q-2.66.17-5.1 1.07v-.61c0-12.34 8.15-22.49 18.62-23.76l.14-.02a18 18 0 0 1 4.18 0 19 19 0 0 1 9.05 3.59 23 23 0 0 1 6.1 6.79l.24.41q.28.5.53.99l.1.21.08.16.12.26.14.29.18.39.12.28.07.16.14.34.12.31.13.34.11.3.11.3.26.82.11.38.09.31.05.18.05.2.05.21v.01l.06.26.03.13.06.26.03.15.06.29.05.23.03.17.05.28.03.18v.01l.03.17v.04l.04.28.05.37.03.22.02.13.02.13.03.3.01.13.04.44a13 13 0 0 1 .07 1.1v.4l.01.5z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m166.98 110.79-1.08 7.66a25 25 0 0 0-7.58-3.04l.05-.44.05-.42v-.02l.04-.44v-.02l.03-.37.02-.37.03-.74v-1.13l-.01-.5v-.4l-.01-.22-.06-.88-.04-.44-.01-.13-.03-.3q0-.07-.02-.13l-.02-.13-.03-.22-.05-.37-.04-.28v-.04q0-.09-.03-.17v-.01l-.03-.18-.05-.28q0-.09-.03-.17l-.05-.23-.06-.29-.03-.15-.06-.26-.03-.13-.06-.26v-.01l-.05-.21-.05-.2-.05-.18-.09-.31-.11-.38-.26-.82-.11-.3-.11-.3-.13-.34-.12-.31-.14-.34-.07-.16-.12-.28-.18-.39-.14-.29-.12-.26-.08-.16-.1-.21a23 23 0 0 0-.77-1.4l-.24-.41 8.6-.7a26 26 0 0 1 3.63 12.34q.03.55.02 1.11z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M136.54 116.9a25 25 0 0 0-8.38 3.88l-.08-.06a24.6 24.6 0 0 0-17.04-4.9 20 20 0 0 1 5.85-3.36q2.44-.9 5.1-1.07h.01q.58-.04 1.18-.04h.9l.17.02.27.02a21 21 0 0 1 1.73.2l.25.04.07.01q.08 0 .17.03l.25.05.06.01.31.07.28.07.1.02.63.17.33.1.33.11h.01l.28.1.07.02.28.1.03.01.25.1a11 11 0 0 1 1.43.63l.2.1.1.05.18.1.23.12.48.27.53.31.2.12.14.09q.48.31.94.65l.27.2.04.03.26.2.27.22.26.21.05.05.2.17.59.53.24.23z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m144.77 115.73-4.08.51q-2.12.15-4.14.67l-.24-.23-.59-.53-.2-.17-.05-.05-.26-.21-.27-.22-.26-.2-.04-.03-.27-.2q-.46-.34-.94-.65l-.14-.09-.2-.12-.53-.31-.48-.27-.23-.12-.18-.1-.1-.05-.2-.1-.49-.23-.94-.4-.25-.1-.03-.01-.28-.1-.07-.02-.28-.1h-.01l-.33-.11-.33-.1-.63-.17-.1-.02-.28-.07-.31-.07-.06-.01-.25-.05-.17-.03-.07-.01-.25-.04q-.47-.08-.95-.13l-.78-.07-.27-.02h-.33l-.12-.01h-.62q-.6 0-1.18.04l6.87-.83a18 18 0 0 1 2.73-.2c4.26 0 8.22 1.47 11.52 3.98q.86.65 1.64 1.39z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m100.85 116.94-1.11.12h-.01q-3.5.18-6.73 1.3l-.52-.39-.27-.19a18 18 0 0 0-1.39-.88l-.24-.14-.24-.13-.19-.1-.16-.08q-.4-.21-.81-.39l-.13-.06-.14-.06-.18-.08-.13-.06-.13-.05-.79-.3-.08-.03-.28-.1-.29-.1-.95-.28-.27-.07-.36-.08-.23-.05h-.04l-.33-.07-.33-.06-.25-.04-.21-.03-.54-.07a18 18 0 0 0-3.36-.08l6.97-.84 1.02-.12h.02a18.5 18.5 0 0 1 12.68 3.52z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M93 118.36a27.6 27.6 0 0 0-13.77 10.89 27 27 0 0 0-7.11-6.43 25 25 0 0 0-4.66-2.31 19.5 19.5 0 0 1 13.96-6.16 19 19 0 0 1 2.65.19l.21.03.25.04.33.06.33.07h.04l.23.05.36.08.27.07.95.28.29.1.28.1q.05 0 .08.03l.79.3.13.05.13.06.18.08.14.06.13.06.81.39.16.08.19.1.24.13.24.14a20 20 0 0 1 1.66 1.07l.52.39z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m72.11 122.81-7.02.57-5.75.47-1.05-.6-1.13-.58-.15-.07-.89-.4-.56-.23-.56-.21-.85-.3-.58-.18-.63-.18-.21-.05-.59-.15-.26-.06-.26-.06-.26-.05-.24-.05-.81-.14-.46-.07-.23-.03-.46-.05-.23-.02-.34-.03h-.02l-.33-.03-.35-.02-.35-.02-.93-.02 7.27-.77 5.07-.54q4.47.02 8.5 1.54 2.44.92 4.66 2.31z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M79.23 129.24a33 33 0 0 0-4.92 11.74q-.45 2.13-.64 4.36h-.23l-.08-.41-.05-.27-.06-.32-.04-.2-.02-.1-.29-1.24-.08-.32-.05-.17-.08-.29-.12-.41-.11-.35-.04-.12-.05-.15-.01-.04-.12-.38-.07-.2-.07-.22-.08-.22-.12-.34-.11-.29v-.02l-.14-.36-.13-.33-.07-.18-.16-.39-.33-.77-.17-.38-.18-.38-.09-.19-.16-.32-.35-.68-.15-.28-.2-.36-.22-.39-.18-.31-.22-.36-.21-.33-.19-.3-.14-.21-.13-.19-.23-.34-.16-.24-.13-.18-.38-.52-.13-.17-.15-.2-.13-.16-.41-.51-.1-.12-.22-.26-.09-.11-.16-.18-.25-.29-.12-.14-.19-.21-.19-.21-.22-.23-.21-.22-.3-.3-.6-.59 12.63-1.04a28 28 0 0 1 2.59 2.87z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M76.63 126.37 64 127.41l-.31-.29-.24-.21-.27-.24-.28-.24-.28-.24-.28-.23-.24-.19-.07-.05-.27-.21-.59-.44-.22-.16-.7-.48-.29-.19-.31-.19-.31-.19 5.75-.47 7.02-.57a27 27 0 0 1 4.52 3.56z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m72.36 140.99-11.63.1-40.02.36.04-.15.19-.6.02-.05.08-.24.05-.16.05-.16c4.01-11.62 13.9-19.85 25.46-19.85h.01l.94.02.35.02.35.02.33.03h.02l.34.03.23.02.46.05.23.03.46.07.81.14.24.05.26.05.26.06.26.06.59.15.21.05.63.18.58.18q.43.14.85.3l.56.21.56.23.89.4.15.07q.57.27 1.13.58l.21.11.84.49.31.19.31.19.29.19q.35.22.7.48l.22.16.59.44.27.21.07.05.24.19.28.23.28.24.28.24.27.24.24.21.31.29.6.59.3.3.21.22.22.23.19.21.19.21.12.14.25.29.16.18.09.11.22.26.1.12.41.51.13.16.15.2.13.17.38.52.13.18.16.24.23.34.13.19.14.21.19.3.21.33.22.36.18.31.22.39.2.36.15.28.35.68.16.32.09.19.18.38.17.38.33.77.16.39.07.18.13.33.14.36v.02l.11.29.12.34.08.22.07.22.07.2.12.38.01.04z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m206.96 142.24-16.52.12-8.1.06h-1.99q-.12-1.12-.31-2.22a34 34 0 0 0-3.08-9.49 31 31 0 0 0-4.88-7.15q-1.42-1.56-3.03-2.87a24.4 24.4 0 0 1 10.31-2.74l.35-.01h.58a23 23 0 0 1 3.73.29l.47.08.45.08.17.03.17.03.39.09q.7.17 1.39.36l.46.14.59.19.09.03.45.16.22.08.44.17.22.09.44.18.43.19.86.41.42.22.33.18.14.08.35.2h.01a15 15 0 0 1 1.22.75l.4.26.37.25.05.04.34.24.3.22.15.11.23.18.16.12.33.26.37.3h.01l.36.31a30 30 0 0 1 4.8 5.34l.25.36.33.49.2.3.17.28.16.25.17.28.35.6.17.3.16.3.32.61.16.31.12.24.13.26.14.29.13.29.12.26.22.5.04.1.19.46.08.21.23.61.09.24.11.31.09.27.02.06.1.29.08.25.21.68.09.31.09.31.04.15.03.09.02.08.09.32.02.08.08.3.06.25v.01l.08.32.04.19v.01l.07.29.02.08.02.1.03.15.03.15v.04z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M218.71 146.9h-11.13v-.08l-.01-.08v-.38l-.01-.15-.01-.16v-.32l-.01-.1-.02-.21-.05-.4v-.07l-.01-.08-.01-.11-.01-.11-.01-.1v-.02l-.07-.49-.08-.49-.05-.29-.03-.16-.03-.16-.03-.19-.04-.19-.06-.29v-.02l-.03-.17-.03-.15-.02-.1-.02-.08-.02-.11-.04-.18v-.01l-.04-.19-.08-.32v-.01l-.06-.25-.08-.3-.02-.08-.09-.32-.02-.08-.03-.09-.04-.15-.02-.06-.07-.26-.09-.31-.21-.68-.08-.25-.1-.29-.02-.06-.09-.27-.11-.31-.09-.24-.23-.61-.08-.21-.19-.46-.04-.1-.22-.5-.12-.26-.13-.29-.14-.29-.13-.26-.12-.24-.16-.31-.32-.61-.16-.3-.17-.3-.35-.6-.17-.28-.16-.25-.17-.28-.2-.3-.58-.85 11.33-.93a34 34 0 0 1 5.78 18.21z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m212.93 128.69-11.33.93q-2.12-3-4.8-5.34l11.48-.94a30 30 0 0 1 4.65 5.35Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m208.28 123.34-11.48.94-.36-.31h-.01l-.37-.3-.33-.26-.16-.12-.23-.18-.15-.11-.3-.22-.34-.24-.05-.04-.37-.25-.4-.26-.81-.51-.41-.24h-.01l-.35-.2-.14-.08-.33-.18-.42-.22-.86-.41-.43-.19-.44-.18-.22-.09-.44-.17-.22-.08-.45-.16-.09-.03-.59-.19-.46-.14q-.69-.2-1.39-.36l-.39-.09-.17-.03-.17-.03-.45-.08-.47-.08-.96-.13q-1.36-.16-2.77-.16h-.58l-.35.01 7.19-.89.79-.1.17-.03.18-.03q1.8-.28 3.66-.28c6.39 0 12.27 2.51 16.93 6.73z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m172.08 123.55-8.24.68-.44.04-2.41.2-.27-.28-.2-.2-.15-.15-.18-.18-.29-.28-.15-.14-.25-.23-.4-.36-.46-.39-.2-.17-.21-.17-.04-.03-.2-.16q-.4-.32-.81-.61l-.19-.14-.21-.15-.43-.3-.35-.23-.35-.22h-.01l-.36-.22-.36-.22-.25-.14-.21-.12-.38-.21-.03-.01-.38-.2-.25-.13-.51-.25-.26-.12-.52-.23h-.02l-.21-.09-.56-.23-.53-.2-.27-.1-.27-.09-.27-.09-.27-.09-.27-.08-.27-.08-.27-.08-.26-.07-.26-.07-.31-.07-.28-.07-.56-.12-.28-.06-.28-.05h-.02l-.27-.05-.28-.05-.29-.04-.29-.04-.12-.01h-.01l-.22-.03q-.12 0-.23-.03l-.62-.06-.63-.04-.63-.02h-.63q-.88 0-1.76.06l4.08-.51 5-.62.55-.07.61-.06h.04q1.09-.1 2.2-.1 2.64 0 5.15.56 4.05.9 7.58 3.04a28 28 0 0 1 6.18 5.1z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m169.46 142.51-18.34.13-7.83.05h-.31l-2.63.02a34 34 0 0 0-1.6-7 32 32 0 0 0-5.35-9.83l-.09-.11-.09-.11-.21-.26-.21-.25-.18-.21a17 17 0 0 0-.88-.95l-.19-.2-.34-.34-.34-.33-.28-.27-.14-.13-.25-.23-.02-.02-.19-.17-.17-.15-.22-.19-.01-.01-.47-.39-.24-.19-.15-.12-.16-.13-.41-.32a25 25 0 0 1 8.38-3.88 24 24 0 0 1 5.9-.73h.63l.63.02.63.04q.32.02.62.06.12 0 .23.03l.22.03h.01l.12.01.29.04.29.04.28.05.27.05h.02l.28.05.28.06.56.12.28.07.31.08.26.07.26.07.27.08.27.08.27.08.27.09.27.09.27.09.27.1.53.2.56.23.21.09h.02l.52.23.26.12.51.25.25.13.38.2.03.01.38.21.21.12.25.14.36.22.36.22h.01l.35.22.35.23.43.3.21.15.19.14.81.61.2.16.04.03.21.17.2.17.46.39.4.36.25.23.15.14.47.46.15.15.2.2.27.28.36.38.04.05.23.26.03.03.15.18.33.39.2.25.07.08.07.09.04.05.04.05.15.19.05.06.2.26.05.07.03.05.05.07.09.12.1.13.08.11.1.14.03.04.16.22.07.1.07.1.02.03.02.03.19.28.31.46.15.23.05.08.1.16.13.2.02.02.06.09.03.04.03.04.02.02.08.14.01.02.21.36.28.48.13.23v.01l.03.05.1.19.13.25.13.25.32.63.18.38.18.39.17.39.01.03.3.7.03.07.16.39.06.16.07.18.05.14.07.19.06.17.01.03.11.3.04.12.06.17v.03q0 .04.03.08l.05.16.1.29v.02l.03.09.03.09.05.15.05.15.13.45.08.29.08.29.1.36.05.18.01.04.07.28.07.29.07.29.01.07.09.43v.03l.07.36.03.15.03.15.01.08.04.21.05.27.01.07v.09l.01.07.03.18.04.25.03.21.03.18v.05l.01.07z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M180.55 146.25v.42l-.13.24h-10.61v-.86l-.01-.23v-.24q0-.14-.02-.27l-.02-.32-.02-.27-.03-.34-.06-.57v-.07l-.05-.45-.01-.12-.08-.64-.01-.07v-.05l-.03-.18-.03-.18v-.04l-.04-.25-.03-.18-.01-.07v-.09l-.01-.07-.05-.27-.04-.21-.01-.08-.03-.15-.03-.15-.07-.36v-.03l-.09-.43-.01-.07-.07-.29-.07-.29-.07-.28-.01-.04-.05-.18-.1-.36-.08-.29-.07-.25-.01-.03-.13-.45-.05-.15-.05-.15-.03-.09-.03-.09v-.02l-.1-.29-.05-.16q0-.04-.03-.08v-.03l-.06-.17-.04-.12-.11-.3-.01-.03-.06-.17-.07-.19-.05-.14-.07-.18-.06-.16-.16-.39-.03-.07-.01-.03-.14-.32-.03-.08-.12-.27-.01-.03-.17-.39-.18-.39-.18-.38-.32-.63 10.94-.9a34 34 0 0 1 3.39 11.73v.09l.04.38v.06l.02.24v.06l.02.29.03.42.02.36.02.31.01.29v1.33z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m176.96 130.7-10.94.9-.13-.25-.13-.25-.1-.19q0-.03-.03-.05v-.01l-.13-.23-.07-.12-.07-.12-.14-.24-.21-.36-.01-.02-.08-.14-.02-.02-.03-.04-.03-.04-.06-.09-.02-.02-.06-.09-.08-.12-.02-.03-.07-.11-.05-.08-.15-.23-.31-.46-.12-.18-.09-.13-.02-.03-.07-.11-.07-.1-.09-.13-.07-.09-.03-.04-.1-.14-.08-.11-.1-.13-.09-.12-.05-.07-.03-.05-.05-.07-.2-.26-.05-.06-.15-.19-.04-.05-.04-.05-.07-.09-.07-.08-.02-.03-.01-.02-.13-.16-.03-.04-.33-.39-.15-.18-.03-.03-.23-.26-.04-.05-.36-.38 2.41-.2.44-.04 8.24-.68a31 31 0 0 1 4.88 7.15z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m116.73 122.81.19.16-.05-.05-.14-.12z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m128.07 120.72-12.72 1.04-.23-.16-.13-.09a18 18 0 0 0-1.17-.76l-.39-.24-.93-.52-.27-.15-.34-.18-.31-.15q-.68-.33-1.37-.62l-.3-.12-.33-.13h-.01l-.33-.12-.72-.25-.58-.18-.14-.04-.24-.07-.24-.07-.04-.01-.15-.04-.75-.19-.32-.07-.33-.07-.29-.06-.16-.03-.16-.03-.21-.04-.29-.05-.34-.05-.11-.02-.23-.03-.46-.05-.35-.03-.35-.03-.24-.02-.23-.01-.41-.02-.76-.02h-.82l-.58.02 1.11-.12 9.14-1q.52-.08 1.05-.12a23 23 0 0 1 6.17.23c3.96.66 7.65 2.29 10.87 4.67z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M140.62 146.9h-1l.08-1.57h-11.56l-.05-.5v-.05l-.06-.54-.04-.33v-.09l-.16-1.08-.06-.36-.09-.48-.09-.48-.04-.2-.04-.2v-.04l-.03-.13-.05-.21-.03-.15-.01-.05-.07-.32-.03-.1V140l-.02-.09v-.01l-.04-.16v-.04l-.01-.06-.04-.16-.11-.41v-.03l-.05-.17-.09-.31-.05-.16v-.02l-.04-.13-.03-.1-.07-.21-.06-.2-.02-.07-.02-.06-.13-.41-.08-.25-.1-.27-.08-.24-.11-.29-.09-.24-.04-.12-.07-.18-.03-.08-.07-.17-.02-.06-.11-.28-.14-.34-.09-.22-.25-.55-.26-.55-.3-.61-.06-.12v-.02l-.03-.07-.14-.27-.14-.26-.14-.26-.08-.15-.09-.15-.02-.03-.11-.19-.11-.2-.11-.2-.22-.38-.31-.5-.12-.19-.03-.05-.49-.74 12.54-1.03a33 33 0 0 1 3.83 7.76 36 36 0 0 1 1.6 7l.02.19.05.45q0 .14.03.26v.09l.01.05.02.23.02.29.02.22.04.58.01.27v.03l.02.43v1.11z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m134.93 127.95-12.54 1.03-.19-.27-.08-.11-.06-.09-.07-.1-.08-.11-.08-.11-.19-.26-.08-.1-.21-.27-.03-.04-.02-.03-.28-.35-.08-.1-.08-.1-.17-.2-.34-.4-.33-.37-.02-.02-.05-.05-.08-.09-.01-.01-.12-.13-.04-.04-.1-.1-.2-.21-.07-.07-.07-.08-.09-.09-.06-.06-.16-.17-.02-.02-.05-.05-.13-.13-.06-.06-.1-.1-.04-.04-.05-.05-.23-.22-.04-.04-.07-.07-.01-.01-.02-.02-.16-.15-.2-.17-.08-.07-.2-.18-.04-.04-.11-.1-.13-.11-.13-.11-.03-.03-.02-.02-.03-.03-.05-.04-.05-.05-.14-.12-.14-.11-.17-.13-.17-.13-.13-.1-.29-.22-.1-.07h-.01l-.03-.02-.16-.12-.16-.12 12.72-1.04.08.06.41.32.16.13.15.12.24.19.47.39.01.01.22.19.17.15.19.17.02.02.25.23.14.13.28.27.34.33.34.34.19.2.49.52.39.43.18.21.21.25.21.26.09.11.09.11.42.53.37.49q.38.51.73 1.05z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m122.39 128.98-.19-.27z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m127.39 140.5-11.65.1-5.27.05-7.58.07h-.74l-17.08.16-10.76.1q.23-1.08.52-2.14a33 33 0 0 1 4.4-9.6A27.7 27.7 0 0 1 93 118.35q3.22-1.12 6.73-1.3h.01l.58-.02h.82q.39 0 .76.02l.41.02.23.01.24.02q.18 0 .35.03l.35.03.46.05q.11 0 .23.03l.11.02.34.05.29.05.21.04.16.03.16.03.29.06.33.07.32.07.75.19.15.04.04.01.24.07.24.07.14.04.58.18.72.25.33.12h.01l.33.13.3.12q.7.29 1.37.62l.31.15.34.18.27.15.93.52.39.24q.58.36 1.17.76l.13.09.23.16.16.12.16.12.03.02h.01l.1.07.29.22.13.1.17.13.17.13.14.11.14.12.05.05.05.04.03.03.02.02.03.03.26.22.11.1.04.04.2.18.08.07.04.03.16.14.18.17.01.01.07.07.04.04.23.22.05.05.04.04.1.1.06.06.13.13.05.05.02.02.16.17.06.06.09.09.07.08.07.08.2.21.1.1.04.04.12.13.01.01.08.09.05.05.02.02.33.37.34.4.17.2.08.1.08.1.28.35.02.03.03.04.21.27.08.1.19.26.08.11.08.11.07.1.06.09.08.11.19.27.49.74.03.05.12.19a14 14 0 0 1 .64 1.08l.11.2.11.19.02.03.09.15.22.41.14.26.14.27.03.07v.02l.06.12.3.61.26.55.25.55.09.22.14.34.11.28.09.23.03.08.07.18.04.12.09.24.11.29.08.24.08.24.01.04.08.25.12.38.05.14v.01l.06.2.07.21.03.1.04.13v.02l.05.16.09.31.05.17v.03l.11.41.06.22v.04l.04.16v.01l.02.09v.02l.03.1.08.37z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M128.14 145.33H73.66q.2-2.23.64-4.36l10.76-.1 17.08-.15h.74l7.58-.07 5.27-.05 11.65-.1.07.36.03.13v.04l.04.2.04.2.09.48.09.48.06.36.02.1.08.51.06.47v.09l.04.33.02.17.04.37v.05l.05.5z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M73.43 145.33H19.79l.06-.34.13-.67.07-.33.07-.33.1-.42.06-.24.17-.65.17-.61v-.02l.08-.26 40.02-.36 11.63-.1.05.15.04.12.11.35.12.41.08.29.05.17.08.32.02.08q.15.57.27 1.16l.02.1.04.2.06.32.05.27.08.41z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M169.81 146.9h-29.19v-1.11l-.02-.43v-.03l-.01-.27-.04-.58-.02-.22-.02-.29v-.09l-.01-.14v-.05l-.03-.35-.05-.45-.02-.19 2.63-.02h.31l7.83-.06 18.34-.13.08.64.07.64.06.57.03.34.02.27.02.32.02.27v.24l.01.23v.08l.01.36v.43z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M207.58 146.9h-27.04v-1.99l-.01-.29-.02-.31-.02-.36-.03-.42-.02-.29v-.06l-.02-.24v-.06l-.04-.38v-.09h1.99l8.1-.07 16.52-.12.06.29.04.19.03.19.03.16.03.16.05.29.08.49.1.73.01.11.02.15.05.4.02.21.01.1v.32l.01.16.01.15v.55z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M6.66 106.55v12.22" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M.55 112.66h12.21" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M24.58 84.91v9.49" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M21.23 89.65h6.7" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M266.38 154.15v2.97" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M260.74 149.39h-2.66" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M266.14 144.59v-2.97" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M271.78 149.35h2.66" strokeWidth={strokeWidth} />
    </svg>
  );
};
